<script setup lang="ts">
import { computed } from 'vue'
import type { BadgeVariants } from '@/components/ui/badge'
import { Badge } from '@/components/ui/badge'
import { ROLE_LABELS } from '@/types/api'

/**
 * Роль приходит `string`, а не union `Role`: по проводу едет `"ROLE_ADMIN"`,
 * но компонент переживает и появление третьей роли, и короткую форму из БД —
 * незнакомое значение просто печатается как есть.
 */
const props = defineProps<{
  role: string
}>()

const VARIANTS: Record<string, BadgeVariants['variant']> = {
  ROLE_ADMIN: 'default',
  ROLE_VIEWER: 'secondary',
}

/** Короткие формы (`admin`) — на случай, если значение пришло не с провода. */
const ALIASES: Record<string, string> = {
  admin: 'ROLE_ADMIN',
  viewer: 'ROLE_VIEWER',
}

const view = computed(() => {
  const key = ALIASES[props.role] ?? props.role
  const label = ROLE_LABELS[key as keyof typeof ROLE_LABELS]
  return label && key !== 'ROLE_UNSPECIFIED'
    ? { label, variant: VARIANTS[key] }
    : { label: props.role, variant: 'outline' as const }
})
</script>

<template>
  <Badge :variant="view.variant">
    {{ view.label }}
  </Badge>
</template>
